import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="final-cta" className="py-10 px-4 bg-warm-900 text-warm-50 relative overflow-hidden" data-id="element-1">
      {/* Subtle background texture/glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-gold/10 blur-[100px] rounded-full pointer-events-none" data-id="element-2" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-3">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 font-heading text-warm-50" data-id="element-4">
          Empieza esta <span className="text-gold italic" data-id="element-5">misma noche</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="space-y-4 mb-12 text-xl md:text-2xl text-warm-100/80 font-light" data-id="element-6">
          <p data-id="element-7">No necesitas más fuerza de voluntad.</p>
          <p data-id="element-8">Solo necesitas un sistema.</p>
          <p className="text-lg md:text-xl mt-6 text-warm-100/60" data-id="element-9">
            Haz clic ahora y transforma la parte más caótica de tu día en el
            momento más tranquilo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} data-id="element-10">
          <motion.a href="https://vidaconmetodo.com/cart/44482692808819:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-block bg-transparent border-2 border-gold text-gold hover:bg-gold hover:text-warm-900 font-bold py-5 px-10 rounded-full text-lg md:text-xl transition-colors duration-300" data-id="element-11">
            OBTENER EL MÉTODO CENA Y CAMA
          </motion.a>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="mt-8" data-id="element-12">
            <div className="inline-block bg-red-600 text-white text-sm font-bold px-3 py-1 rounded-full mb-3 tracking-wide" data-id="element-13">
              68% OFF
            </div>
            <div className="flex items-baseline justify-center gap-3" data-id="element-14">
              <span className="text-xl text-warm-100/40 font-heading line-through" data-id="element-15">
                $19.99
              </span>
              <span className="text-4xl md:text-5xl font-bold text-gold font-heading tracking-tight" data-id="element-16">
                $6.39
              </span>
              <span className="text-lg text-warm-100/60 font-medium" data-id="element-17">USD</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}